import { Component } from "react";
import "../../../../styles/css/searchspace.scss";
import "../../../../App.css";
import 'react-modern-drawer/dist/index.css';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { getAllBuildingsData } from "../../../../Common/Helper";
import { appContext } from "../../../../AppContext";
import { Box, TextField } from '@mui/material';
import { ONELENS_SPACEANALYTICS_OVERVIEW } from "../../../../app/constants";
import IbssDatePicker from "../../../../Components/Inputs/DatePicker/IbssDatePicker";
import { withRouter } from "react-router-dom";
import IbssButtonRedo from "../../../../Components/Buttons/Button/IbssButton";
import { DateTime } from "luxon";
import { DateView } from "@mui/x-date-pickers";
import IbssDrawer from "../../../../Components/Drawer/IbssDrawer";
import IbssSvgIcon from "../../../../Components/Icons/SvgIcon/IbssSvgIcon";
import { Icons } from "../../../../Common/AllsvgIcons";
import { IQuery } from "./ViewSpaceAnalyticsOverview";

type OptionNumType = {
    label: string,
    value: number
}

type OptionStrType = {
    label: string,
    value: string
}

type SearchCriteriaState = {
    buildingOptions: Array<OptionNumType>,
    workSpaceTypeOptions: Array<OptionStrType>,
    SpaceTypeOptions: Array<OptionStrType>,
    floorTypeOptions: Array<OptionNumType>,
    zoneOptions: Array<OptionStrType>,
    selectedBuildingOption: string | number, // mistyped in Class State as string | number[]? observed a number in React Components.
    selectedWorkspaceTypes: string,
    selectedSpaceTypes: string;
    selectedFloor: string | number;
    selectedZone: string,
    fmsfc_start_date_for_filter_modal: Date | null, // todo: this should be either a date or a string, not both
    End_Date_For_filter_modal: Date | null, // todo: this should be either a date or a string, not both
    periodTypeOption: Array<OptionNumType>,
    selectedperiodType: number,
}

class SpaceAnalyticsMainSearch extends Component<IProps, SearchCriteriaState>
{
    private alert = appContext().alert;
    private session = appContext().sessionStorageProvider;
    private local = appContext().localStorageProvider;
    private get appState() { return appContext().state; }

    private buildingid = this.session.getBuildingId();
    private labels = appContext().labels;
    private startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    private defaultMonthStartDate = DateTime.fromJSDate(this.startDate).toJSDate();
    private defaultEndDate = DateTime.fromJSDate(this.startDate).endOf('month').toJSDate();

    constructor(props: any) {
        super(props);
        this.state = {
            buildingOptions: [],
            workSpaceTypeOptions: [],
            SpaceTypeOptions: [],
            floorTypeOptions: [],
            zoneOptions: [],
            selectedBuildingOption: "",
            selectedWorkspaceTypes: "",
            selectedSpaceTypes: "",
            selectedFloor: "",
            selectedZone: "",
            fmsfc_start_date_for_filter_modal: null,
            End_Date_For_filter_modal: null,
            periodTypeOption: [],
            selectedperiodType: 1
        }
    }

    public async componentDidMount() {
        const periodType = [
            { label: `${this.labels.HublabelDay}`, value: 3 },
            { label: `${this.labels.HublabelWeek}`, value: 0 },
            { label: `${this.labels.HublabelMonth}`, value: 1 },
            { label: `${this.labels.HublabelYear}`, value: 2 },
        ];
        const bldgOpts = this.makeBuildingOptions(getAllBuildingsData());
        this.setState({
            buildingOptions: bldgOpts,
            periodTypeOption: periodType,
            fmsfc_start_date_for_filter_modal: this.defaultMonthStartDate,
            End_Date_For_filter_modal: this.defaultEndDate
        });
        const userPreferences = this.local.getUserPreferences();
        this.setState({ selectedperiodType: this.props.periodType });
        if (userPreferences.SearchPrefs.DefaultBuilding != null && userPreferences.SearchPrefs.DefaultBuilding != undefined ) {
            this.setState({ selectedBuildingOption: this.props.buildingId });


            if (userPreferences.WorkingHoursPrefs.UserStartTime != null) {
                this.setState({ fmsfc_start_date_for_filter_modal: this.props.periodStartDate.toJSDate() });
            }
            if (userPreferences.WorkingHoursPrefs.UserEndTime != null) {
                this.setState({ End_Date_For_filter_modal: this.props.periodEndDate.toJSDate() });
            }
        }

    }

    // Building option call
    public makeBuildingOptions(data: any) {
        let options: any = [{ label: "All", value: 1 }];
        data.map((obj: any) => {
            options.push({ label: obj['Name'], value: obj['Node_Id'] })
        });
        return options;
    }

    // Space type option call
    public makeSpaceTypeOptions(data: any) {
        let options: any = [];
        const spacesSet = new Set();
        data.map((obj: any) => {
            if (!spacesSet.has(obj['Name'])) {
                options.push({ label: obj['Label'], value: obj['Name'] })
                spacesSet.add(obj['Name'])
            }
        });
        options.unshift({ label: "Any", value: "Any" })
        this.setState({
            SpaceTypeOptions: options,
            selectedSpaceTypes: options[1].value,
        });
    }

    /*Filter calendar according to type day, month, year*/
    public getCalendarView(selectedPeriodType: number) {
        let view: DateView = 'month';
        if (this.state.selectedperiodType === 1) {
            view = view;
        } else if (this.state.selectedperiodType === 2) {
            view = "year";
        } else if (this.state.selectedperiodType === 3) {
            view = "day"
        } else {
            view = "day"
        }
        return view;
    };

    public async handleOnBldngChange(event: SelectChangeEvent) {
        await this.setState({
            selectedBuildingOption: event.target.value
        });
        this.updateBlndgDependentParams();

    };

    public handleOnWorkspaceTypeChange(event: SelectChangeEvent) {
        this.setState({
            selectedWorkspaceTypes: event.target.value,
            selectedSpaceTypes: "Any"
        });
    };

    /* Get last week monday */
    public getMondayOfLastWeek() 
    {
        const today = DateTime.now();
        const first = today.minus({ weeks: 1 }).startOf('week');
        const last = today.endOf('week').minus({ days:1 });
        const monday = first.toJSDate();
        const lastday = last.toJSDate();
        this.setState({ fmsfc_start_date_for_filter_modal: monday });
        this.setState({ End_Date_For_filter_modal: lastday })
    }

    public handlePeriodTypeChange(event: SelectChangeEvent) {
        this.setState({
            selectedperiodType: parseInt(event.target.value)
        })
        if (Number(event.target.value) === 2) {
            this.setState({ fmsfc_start_date_for_filter_modal: new Date(new Date().getFullYear(), 0, 1) });
            this.setState({ End_Date_For_filter_modal: new Date(new Date().getFullYear(), 11, 31) })
        } else if (Number(event.target.value) === 3) {
            this.setState({ fmsfc_start_date_for_filter_modal: new Date(new Date().setDate(new Date().getDate() - 1)) });
            this.setState({ End_Date_For_filter_modal: DateTime.local().endOf('day').toJSDate()});
        } else if (Number(event.target.value) === 0) {
            this.getMondayOfLastWeek();
        } else {
            this.setState({ fmsfc_start_date_for_filter_modal: new Date(new Date().getFullYear(), new Date().getMonth(), 1) });
            this.setState({ End_Date_For_filter_modal: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0) })
        }
    }

    public clear(): void {

        this.setState({
            selectedBuildingOption: this.buildingid,
            selectedWorkspaceTypes: 'Any',
            selectedSpaceTypes: 'Any',
            selectedFloor: 'Any',
            selectedZone: 'Any',
            fmsfc_start_date_for_filter_modal: this.defaultMonthStartDate,
            End_Date_For_filter_modal: this.defaultEndDate,
            selectedperiodType: 1
        });
        
        const filterData = { buildingId: this.buildingid, periodEndDate: DateTime.fromJSDate(this.defaultEndDate), buildingName: this.appState.buildingName, periodStartDate: DateTime.fromJSDate(this.defaultMonthStartDate), periodType: 1, periodTypeValue: "Month" };
        this.props.updateSearchResults(filterData)
    }

    public updateBlndgDependentParams() {
        if (this.state.selectedBuildingOption != undefined && this.state.selectedBuildingOption != null && this.state.selectedBuildingOption != '') {
            this.setState({
                fmsfc_start_date_for_filter_modal: this.defaultMonthStartDate,
                End_Date_For_filter_modal: this.defaultEndDate,
            });
        }
    }

    public selectedMondays = (day: Date | DateTime) => {
        if (this.state.selectedperiodType === 0 && (day instanceof DateTime))
        {
            return day.weekday !== 1;
        }
        return false;
    };

    /* Start_Date & End_Date change as per selection */
    public handleStartDate = (e: Date) => {
        const startDay = e;
        if (this.state.selectedperiodType === 2) {
            this.setState({
                fmsfc_start_date_for_filter_modal: startDay,
                End_Date_For_filter_modal: new Date(new Date(e).getFullYear(), 11, 31),
            });
        } else if (this.state.selectedperiodType === 1) {
            this.setState({
                fmsfc_start_date_for_filter_modal: startDay,
                End_Date_For_filter_modal: new Date(new Date(e).getFullYear(), new Date(e).getMonth() + 1, 0),
            });
        } else if (this.state.selectedperiodType === 0) {
            this.setState({
                fmsfc_start_date_for_filter_modal: startDay,
                End_Date_For_filter_modal: new Date(new Date(e).setDate(new Date(e).getDate() - new Date(e).getDay() + 1 + 6)),
            });
        } else if (this.state.selectedperiodType === 3) {
            this.setState({
                fmsfc_start_date_for_filter_modal: startDay,
                End_Date_For_filter_modal: new Date(new Date(e).setDate(new Date(e).getDate())),
            });
        }
    };

    public async upDateSearchResults() {
        let buildingId = null;
        let filterData: IQuery = {
            buildingId: '',
            periodStartDate: DateTime.now(),
            periodEndDate: DateTime.now(),
            periodType: 0,
            buildingName: ''
          };

        if (this.state.selectedBuildingOption != undefined && this.state.selectedBuildingOption != null && this.state.selectedBuildingOption != '') {
            buildingId = parseInt(this.state.selectedBuildingOption as string)
            const buildingName = this.state.buildingOptions.filter((val: any) => val.value === this.state.selectedBuildingOption);
            filterData = { ...filterData, buildingName: buildingName[0].label, buildingId: this.state.selectedBuildingOption }
        }
        else {
            //set the default value from user prefs
            let buildingId = this.session.getBuildingId();
            filterData = { ...filterData, buildingId: buildingId }
        }

        if (this.state.selectedperiodType || this.state.selectedperiodType === 0) {
            filterData = {
                ...filterData,
                periodType: this.state.selectedperiodType
            }
        }
        if (this.state.fmsfc_start_date_for_filter_modal && this.state.End_Date_For_filter_modal) {
            filterData = { ...filterData, periodEndDate: DateTime.fromJSDate(this.state.End_Date_For_filter_modal), periodStartDate: DateTime.fromJSDate(this.state.fmsfc_start_date_for_filter_modal) }

        }

        this.props.updateSearchResults(filterData)
        this.props.toggleDrawer(false);
    }

    public render() {
        return (

            <>
                <div className="flexMySearch-filter-criteria">
                    <div className="flexMySearch-filter-criteria-header">
                        <span className="flexMySearch-filter-criteria-icon">
                            <IbssSvgIcon fontSize="medium">{Icons.FilterIcon}</IbssSvgIcon>
                        </span>
                        <span className="flexMySearch-filter-criteria-title">{this.labels.HubLabelflexFilterSearchCritera} </span>
                        <span className="flexMySearch-filter-criteria-close" onClick={() => this.props.toggleDrawer(false)}>&times;</span>
                    </div>


                    <div className="flexMySearch-filter-criteria-content">
                        {/* Building select */}
                        <div className="row flexMySearch-filter-criteria-selectBldng-filter">
                            <div className="col-5 card ml-0 flexMySearch-filter-criteria-select-label">{this.labels.HubLabelBuilding}</div>
                            <div className="col-7 d-flex justify-content-end card mr-0 flexMySearch-filter-criteria-select-selectBox">
                                <FormControl fullWidth size="small">
                                    <InputLabel shrink={false} className="fms-fc-placeholder">
                                        {this.state.selectedBuildingOption == '' && '***Select an Option***'}
                                    </InputLabel>

                                    <Select
                                        disabled
                                        displayEmpty
                                        value={this.state.selectedBuildingOption}

                                        onChange={(e: any) => this.handleOnBldngChange(e)}
                                        sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}>

                                        {this.state.buildingOptions.map((eachVal: any) => {
                                            return (
                                                <MenuItem value={eachVal.value}>{eachVal.label}</MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>

                            </div>
                        </div>
                        <div className="flexMySearch-filter-criteria-border" />

                        {/* date and period */}
                        <div className="flexMySearch-filter-criteria-firstLabel">
                            {this.labels.HubLabelDateandTime}
                        </div>
                        {/* Period Type */}
                        <div className="row flexMySearch-filter-criteria-selectBldng-filter">
                            <div className="col-5 card pt-0 ml-0 flexMySearch-filter-criteria-select-label">{this.labels.HublabelPeriodType}</div>
                            <div className="col-7 card pt-0 d-flex justify-content-end mr-0 flexMySearch-filter-criteria-select-selectBox">
                                <FormControl fullWidth size="small">
                                    <Select
                                        value={this.state.selectedperiodType}
                                        onChange={(e: any) => this.handlePeriodTypeChange(e)}
                                        sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}>
                                        {this.state.periodTypeOption.map((eachVal: any) => {
                                            return (
                                                <MenuItem value={eachVal.value}>{eachVal.label}</MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        {/* Date Selection */}
                        <div className="row flexMySearch-filter-criteria-selectBldng-filter">
                            <div className="col-5 card ml-0 flexMySearch-filter-criteria-select-label">{this.labels.HublabelPeriodStartDate}</div>
                            <div className="col-7 d-flex justify-content-end card mr-0 flexMySearch-filter-criteria-select-selectBox">
                                <FormControl fullWidth size="small">
                                    <IbssDatePicker
                                        value={this.state.fmsfc_start_date_for_filter_modal ? DateTime.fromJSDate(this.state.fmsfc_start_date_for_filter_modal) : DateTime.now()}
                                        onChange={(event) => this.handleStartDate(event?.toJSDate() as Date)}
                                        shouldDisableDate={this.selectedMondays}
                                        views={this.state.selectedperiodType == 1 ? ['month', 'year'] : [this.getCalendarView(this.state.selectedperiodType)]}
                                        slotProps={{ textField: { size: 'small' } }}
                                    />
                                </FormControl>
                            </div>
                        </div>
                        <div className="flexMySearch-filter-criteria-border" />
                        {/* buttons */}
                        <div className="right-space-box-cont">
                            <div className="d-flex justify-content-center">
                                <a type="button" className="clear-attendees my-2" onClick={() => this.clear()}>{this.labels.HubLabelClearSelections}</a>
                                <span className="ml-2">
                                    <IbssButtonRedo
                                        variant='contained'
                                        onClick={() => this.upDateSearchResults()}
                                    >
                                        {this.labels.HubButtonUpdate}
                                    </IbssButtonRedo>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(SpaceAnalyticsMainSearch);

export interface IProps 
{  
    buildingId: number;
    floorId: number;
    periodType: number;
    periodStartDate: DateTime;
    periodEndDate: DateTime;
    toggleDrawer: (isOpen: boolean) => void;
    updateSearchResults: (query: IQuery) => void;
}